<template>
	<BaseModal
		:visible="props.visible"
		:title="$t('location')"
		page-mode
		:button-name="$t('select')"
		:loading="loading"
		@close="emit('close')"
		@button-click="select"
		:hide-footer="!editable"
		class="w-full h-full"
	>
		<div class="flex flex-col flex-grow h-full">
			<span v-if="false" class="absolute z-20 flex flex-col items-center left-12 top-20 right-12">
				<div
					class="flex flex-col px-3 py-2 space-y-1 text-xs text-center bg-opacity-50 border shadow-lg bg-slate-200 rounded-xl border-slate-300"
				>
					<span>
						{{ "Outter Center: " + center?.map((v) => v?.toFixed(4)) }}
					</span>
					<span>
						{{ "inner Center: " + state.center?.map((v) => v?.toFixed(4)) }}
					</span>
					<span>
						{{ "Outter Zoom: " + zoom }}
					</span>
					<span>
						{{ "Inner Zoom: " + state.zoom }}
					</span>
				</div>
			</span>
			<BaseMapBox
				:center="state.center || undefined"
				:zoom="state.zoom || undefined"
				@update:center="(v) => editable && (state.center = v)"
				@update:zoom="(v) => editable && (state.zoom = v)"
				class="flex-grow h-full rounded-lg bg-slate-200"
				:editable="editable"
			/>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
const emit = defineEmits<{
	close: []
	select: [number[] | null]
}>()

const props = withDefaults(
	defineProps<{
		visible?: boolean
		center?: number[]
		zoom?: number
		editable?: boolean
		loading?: boolean
	}>(),
	{
		editable: true
	}
)

const state = reactive({
	zoom: null as number | null,
	center: null as number[] | null
})

watch(
	() => props.center,
	() => {
		if (!props.center) return
		state.center = props.center || null
	},
	{
		immediate: true
	}
)

watch(
	() => props.zoom,
	() => {
		if (!props.zoom) return
		state.zoom = props.zoom || null
	},
	{
		immediate: true
	}
)

const select = () => {
	emit("select", state.center)
}
</script>
